export const dispatchSearchRefreshEvent = (data) => {
  const searchRefreshEvent = new CustomEvent("beon.search.results.refresh", {
    detail: { data },
  });
  document.dispatchEvent(searchRefreshEvent);
};

export const dispatchSetupAnchorsEvent = (data) => {
  const setupAnchorsEvent = new CustomEvent("beon.search.setup.anchors", {
    detail: { data },
  });
  document.dispatchEvent(setupAnchorsEvent);
};

export const dispatchInputInitializedEvent = () => {
  const searchConfig = window.bn_config_search_page || {};
  const inputInitializedEvent = new CustomEvent(
    "beon.search.input.initialized",
    {
      detail: {
        data: {
          ...searchConfig,
        },
      },
    }
  );

  document.dispatchEvent(inputInitializedEvent);
};

export const dispatchGA4SearchEvent = ({
  eventAction,
  eventCount,
  eventLabel,
  eventValue,
}) => {
  const event = {
    event: "beonly_search",
    eventAction,
    eventLabel,
  };

  if (eventCount) {
    event.eventCount = eventCount;
  }

  if (eventValue) {
    event.eventValue = eventValue;
  }

  const dataLayer = window.dataLayer || [];
  dataLayer.push(event);
};
